import dayjs from "dayjs"
import { getUserAvatarUrl } from "../../../helpers/userAvatar"
import { getUserFullName } from "../../../helpers/userDisplay"
import {
  resolveSessionCity,
  resolveSessionProject,
} from "../../../helpers/session"

/** Relations for Manage City Shadow Working Events cards. */
export const CITY_SHADOW_LIST_WITH = [
  "creator",
  "collaborators.user",
  "targets.targetable",
]

export const CITY_SHADOW_EVENT_TABS = [
  { key: "all", label: "All" },
  { key: "active", label: "Active", countTone: "awaiting" },
  { key: "ended", label: "Ended", countTone: "approved" },
]

const personName = user => {
  if (!user) return "--"
  return getUserFullName(user, { fallback: "--" })
}

const formatDuration = value => {
  const n = Number(value)
  if (!Number.isFinite(n) || n <= 0) return "--"
  const rounded = Math.round(n * 100) / 100
  return `${rounded}hrs`
}

const formatDatetime = value => {
  if (!value) return "--"
  const parsed = dayjs(value)
  return parsed.isValid() ? parsed.format("MMM D, h:mm A") : "--"
}

const orgLabel = item => {
  const project = resolveSessionProject(item)
  if (project?.name) return project.name
  const city = resolveSessionCity(item)
  if (city?.name) return city.name
  const target = Array.isArray(item?.targets) ? item.targets[0] : null
  const targetable = target?.targetable
  return (
    targetable?.name ||
    targetable?.title ||
    targetable?.city ||
    String(item?.source_type || "Session")
      .replace(/_/g, " ")
      .replace(/\b\w/g, c => c.toUpperCase())
  )
}

const categoryLabel = item => {
  const source = String(item?.type || item?.source_type || "")
    .trim()
    .toLowerCase()
  if (!source) return "Session"
  return source.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())
}

const visibilityLabel = item => {
  const key = String(item?.visibility_type || "global")
    .trim()
    .toLowerCase()
  return key === "private" ? "Private" : "Public"
}

/**
 * Map GET /api/v1/admin/sessions item → Manage City shadow event card.
 */
export const mapCityShadowEventRow = item => {
  const creator = item?.creator || null
  const collaborators = Array.isArray(item?.collaborators)
    ? item.collaborators
    : []
  const attendeeAvatars = collaborators
    .map(entry => getUserAvatarUrl(entry?.user || entry))
    .filter(Boolean)
  const shown = attendeeAvatars.slice(0, 3)
  const totalAttendees =
    collaborators.length || Number(item?.collaborators_count) || 0
  const extra = Math.max(0, totalAttendees - shown.length)
  const status = String(item?.status || "")
    .trim()
    .toLowerCase()
  const visibility = visibilityLabel(item)
  const visibilityType = String(item?.visibility_type || "global")
    .trim()
    .toLowerCase()

  const workingNote = String(item?.working_note || "").trim()
  const apiTitle = String(item?.title || "").trim()
  const apiDescription = String(item?.description || "").trim()
  const title = apiTitle || workingNote || "--"
  const description =
    (apiDescription && apiDescription !== title ? apiDescription : "") ||
    (workingNote && workingNote !== title ? workingNote : "")

  return {
    id: item?.id,
    org: orgLabel(item),
    title,
    description,
    category: categoryLabel(item),
    visibility,
    visibilityKey: visibilityType === "private" ? "private" : "global",
    host: personName(creator),
    datetime: formatDatetime(item?.started_at || item?.created_at),
    duration: formatDuration(item?.total_working_hours),
    status: status === "completed" ? "ended" : status || "active",
    attendees: shown,
    attendeeExtra: extra,
    raw: item,
  }
}
